@if (count > 0 || showIfZero) {
<div class="flex" [ngClass]="showMargin ? 'ml-1 mr-1' : ''">
  <span style="width: 10px; height: 20px" [class]="'rounded-tl-full rounded-bl-full ' + bgClass"> </span>
  <span style="height: 20px" [class]="'text-white text-sm flex justify-center leading-none items-center ' + bgClass">
    <span>{{ count }}</span></span
  >
  <span style="width: 10px; height: 20px" [class]="'rounded-tr-full rounded-br-full ' + bgClass"> </span>
</div>
}
